export const TASK_TYPE = {
  RECOMMENDATION_MODIFICATION: 'RECOMMENDATION_MODIFICATION',
  RECOMMENDATION_REMOVAL: 'RECOMMENDATION_REMOVAL'
} as const

export const TASK_TYPE_TITLE = {
  [TASK_TYPE.RECOMMENDATION_MODIFICATION]: 'Рекомендации к изменению',
  [TASK_TYPE.RECOMMENDATION_REMOVAL]: 'Рекомендации к удалению'
}
